import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IntegrationApp, PbxLabel_Type } from '@proto/integrationapp';

@Component({
  selector: 'app-integration-apps-resources-card',
  templateUrl: './integration-apps-resources-card.component.html',
  standalone: false
})
export class IntegrationAppsResourcesCardComponent {

  @Input() integrationApp: IntegrationApp;
  @Input() isUpgrade: boolean;
  @Input() needsSecret: boolean;

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onResourceImportConfirmed: EventEmitter<void> = new EventEmitter<void>();

  public readonly PbxLabel_Type = PbxLabel_Type;
  public accepted: boolean = false;

  public accept(v: boolean) {
    this.accepted = v;
  }

  continue() {
    this.onResourceImportConfirmed.emit();
  }

  onCancel() {
    this.cancel.emit();
  }

}
